import { IOrganization } from "./i-organization";



export class Organization {
  orgName: string;
  contactName: string;
  parentCompany: string;
  restrictedAnalytes: string[];
  orgId?: number;
  ftpEnabled?: boolean;

  constructor(
    orgName: string,
    contactName: string,
    parentCompany: string,
    restrictedAnalytes: string[],
    orgId?: number,
    ftpEnabled?: boolean,
  ) {
    this.orgName = orgName;
    this.contactName = contactName;
    this.parentCompany = parentCompany;
    this.restrictedAnalytes = restrictedAnalytes || [];
    this.orgId = orgId;
    this.ftpEnabled = ftpEnabled;
  }

  static organizationFactory(organizationData: IOrganization): Organization {
    return new Organization(
      organizationData.orgName,
      organizationData.contactName,
      organizationData.parentCompany,
      organizationData.restrictedAnalytes,
      organizationData.orgId,
      organizationData.ftpEnabled,
    );
  }

  get restrictedAnalytesSortOrder(): number {
    if (this.restrictedAnalytes && this.restrictedAnalytes.length > 0) {
      return 0;
    } else {
      return 1;
    }
  }

  get ftpAccess(): string {
    return this.ftpEnabled ? 'Yes' : '';
  }
}
